import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PlantBackground from '../components/PlantBackground';
import './ProductPage.css';

const ProductPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Products — Nisarg Nursery';
  }, []);

  return (
    <div className="product-page">
      {/* Hero Section */}
      <section className="product-hero">
        <PlantBackground />
        {/* Hanging Plants */}
        <div className="hanging-plants-container">
          <img src="/images/hanging.jpg" alt="Hanging Plant" className="hanging-plant hanging-plant-1" />
          <img src="/images/hanging1.jpg" alt="Hanging Plant" className="hanging-plant hanging-plant-2" />
          <img src="/images/hanging2.jpg" alt="Hanging Plant" className="hanging-plant hanging-plant-3" />
        </div>
        <div className="product-hero-content">
          <h1 className="product-hero-title">Discover Our Premium Plant Collection</h1>
          <p className="product-hero-desc">
            Explore a wide range of indoor plants, outdoor plants, flowering plants, herbal plants, fruit plants, hanging plants, and plant library solutions designed to bring natural beauty and greenery to every space.
          </p>
          <Link to="/plants" className="product-cta btn-primary">
            Explore Plants
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ProductPage;
